module.exports = __webpack_public_path__ + "static/media/temp_32.70e390cd.jpg";